import { render, staticRenderFns } from "./PaymentSuccessful.vue?vue&type=template&id=44dff4d6&scoped=true&"
import script from "./PaymentSuccessful.vue?vue&type=script&lang=js&"
export * from "./PaymentSuccessful.vue?vue&type=script&lang=js&"
import style0 from "./PaymentSuccessful.vue?vue&type=style&index=0&id=44dff4d6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44dff4d6",
  null
  
)

export default component.exports